<script setup lang="ts">
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';

const { seoMeta } = useSiteConfigs();
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: 'https://mrbilit.com',
        },
    ],
});

useSeoMeta({
    title: seoMeta.title,
    description: seoMeta.description,
    ogDescription: seoMeta.description,
    ogTitle: seoMeta.title,
});
</script>

<template>
    <InformationContainer />
</template>
